module.exports = __webpack_public_path__ + "static/media/loading-spinner.bb826fbf.svg";